var CurrentUserApiService = function (jsonrpc) {
    var service = jsonrpc.newService('current_user');
    this.info = service.createMethod('info');
};
CurrentUserApiService.$inject = ['jsonrpc'];


export default function(app){
    app.service('CurrentUserApiService', CurrentUserApiService)
};
